import { addDays, startOfMonth, subDays, subMonths, today } from '../../../../utils/date';

const rootNode = document.getElementById('finance-landing-page-root');

const defaultCutoffDate = subDays(today(), 4);
// min(today - 4 days, cutoff date) from the backend
const advancedCutoffDate = rootNode?.dataset?.advancedCutoffDate || defaultCutoffDate;
// An attribute equal to the rolling 4-day lag means no real user cutoff
const hasUserCutoff = advancedCutoffDate !== defaultCutoffDate;

// The +1 day counts a month ending exactly on a user cutoff as closed;
// on the rolling lag the boundary day's data may not be loaded yet
export const lastTransitionDate = startOfMonth(
  subMonths(hasUserCutoff ? addDays(advancedCutoffDate, 1) : advancedCutoffDate, 2)
);
